/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAutomation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AppointmentType from './AppointmentType/index'
import AutomationType from './AutomationType/index'
import CancelAction from './CancelAction/index'
import EventActions from './EventActions/index'
import EventType from './EventType/index'
import LastModified from './LastModified/index'
import Location from './Location/index'
import Name from './Name/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import SectionTitle from './SectionTitle/index'
import TriggerType from './TriggerType/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EditAutomation({
  children,
  viewPath = "/DesignSystem/EditAutomation"
  
}) {
let automationEventIdValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'event_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let automationEventTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'event_type',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let automationAppointmentTypeIdsValueData = fromData.useDataFormat({ viewPath,
context: 'automation',
path: 'appointment_type_ids',
format: fromFormat.isNotEmptyList,
})
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text={automationEventIdValueData ? "Edit Automation" : "Add new Automation"}
 marginTop={dtSpaceXs}
 level="h2"
 data="automation.event_id"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Enhance your workflow management with the Greyfinch Automation Hub. Automations can be based on treatment status or appointment status changes."
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral500}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 weight="medium"
 size="xmedium"
 color={dtColorsNeutral900}
 text="Learn how this works"
 goTo="https://support.greyfinch.com/hc/en-us/articles/24002245316621-Automation-Hub"
/>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 theme="light"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceL}
/>
<div
  data-testid="EditAutomation.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<Name
  viewPath={`${viewPath}/Name`}
/>
<AutomationType
  viewPath={`${viewPath}/AutomationType`}
/>
<EventType
  viewPath={`${viewPath}/EventType`}
/>
</div>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 width="100%"
 flexDirection="column"
 marginTop={dtSpaceS}
 borderColor={automationEventTypeValueData ? dtColorsNeutral200 : "transparent"}
 data="automation.event_type"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingLeft={0}
 paddingRight={0}
 paddingTop={0}
 paddingBottom={dtSpaceS}
>
{childProps => (
<React.Fragment>
<SectionTitle
{...childProps}
  viewPath={`${viewPath}/SectionTitle`}
/>
<AppointmentType
{...childProps}
  viewPath={`${viewPath}/AppointmentType`}
/>
<div
  data-testid="EditAutomation.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TriggerType
  viewPath={`${viewPath}/TriggerType`}
/>
<LastModified
  viewPath={`${viewPath}/LastModified`}
/>
<EventActions
  viewPath={`${viewPath}/EventActions`}
/>
</div>
</React.Fragment>
)}
</TysiaCardContent>
)}
</TysiaCard>
<div
  data-testid="EditAutomation.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-15nBmx': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
</div>
{children}
</React.Fragment>)
}